export default __webpack_public_path__ + "/assets/bg-base-00.jpg";